export default "__VITE_PUBLIC_ASSET__81ad3049__"